// ContextMenuItem definitions converted to jquery-contextmenu's item format.
// No AngularJS here, so the conversion can be tested on its own.

import { ContextMenuItem } from './context-menus';

export type MenuItemById = { [index: string]: ContextMenuItemForLib; }
export type RegularMenuItemForLib = {
    name: string;
    disabled?: boolean;
    visible?: boolean;
    icon?: string | ((opt: any, $itemElement: JQuery, itemKey: string, item: RegularMenuItemForLib) => string);
    callback: () => boolean | void | undefined;
};

export type SubMenuItemForLib = {
    name: string;
    items: MenuItemById;
    visible?: boolean;
    callback?: () => boolean | void | undefined;
}
export type SeparatorForLib = string;

type ContextMenuItemForLib = RegularMenuItemForLib | SeparatorForLib | SubMenuItemForLib;

/**
 * Replaces a menu item's content with an optional icon, the name and an
 * optional shortcut. The name and shortcut are text: names carry task, group
 * and project captions.
 */
function renderItemContent(itemElement: HTMLElement, content: { iconClass: string | null; spaceAfterIcon: boolean; name: string; shortcutKey?: string | null }): void {
    const doc = itemElement.ownerDocument;
    itemElement.textContent = '';

    if (content.iconClass) {
        const icon = doc.createElement('i');
        icon.className = `fa ${content.iconClass}`;
        icon.setAttribute('aria-hidden', 'true');
        itemElement.appendChild(icon);
        if (content.spaceAfterIcon) {
            itemElement.appendChild(doc.createTextNode(' '));
        }
    }

    const name = doc.createElement('span');
    name.textContent = content.name;
    itemElement.appendChild(name);

    if (content.shortcutKey) {
        const shortcut = doc.createElement('span');
        shortcut.className = 'context-menu-item-hotkey';
        shortcut.textContent = content.shortcutKey;
        itemElement.appendChild(shortcut);
    }
}

// Exported for menus that own their own $.contextMenu options (Gantt task
// list, resource strips): raw ContextMenuItems handed straight to the lib
// silently drop icons, disabled reasons, and toggle rendering.
export function convertMenuItemDefinition(srcItems: ContextMenuItem[], getNextId: () => string): MenuItemById {

    let destItems: MenuItemById = {};

    for (const srcItem of srcItems) {
        let destItemId = `item_${getNextId()}`;

        // if we have a togglging check item, we have to convert it to a regular item with special logic
        if (typeof srcItem === 'object' && 'isChecked' in srcItem) {

            const srcCheckItem = srcItem;

            let itemElement: JQuery | null = null;

            function updateCheckItem() {
                if (itemElement) {
                    renderItemContent(itemElement[0], {
                        iconClass: srcCheckItem.isChecked() ? 'fa-check-square-o' : 'fa-square-o',
                        spaceAfterIcon: true,
                        name: srcCheckItem.name,
                    });
                }
            }

            const newItem: ContextMenuItemForLib = {
                name: srcItem.name,
                icon: (opt: any, $itemElement: JQuery, itemKey: string, item: RegularMenuItemForLib) => {
                    itemElement = $itemElement;
                    updateCheckItem();
                    return ""; // no special class name required
                },
                callback: () => {
                    srcItem.callback();
                    updateCheckItem();
                    return false;
                },
                visible: srcItem.visible,
            }

            destItems[destItemId] = newItem;
        } else if (typeof srcItem === 'object' && 'items' in srcItem) {

            const newItem: SubMenuItemForLib = {
                name: srcItem.name,
                visible: srcItem.visible,
                items: convertMenuItemDefinition(srcItem.items, getNextId),
            }

            destItems[destItemId] = newItem;
        } else if (typeof srcItem === 'object') {

            const newItem: ContextMenuItemForLib = {
                name: srcItem.name,
                icon: (opt: any, $itemElement: JQuery, itemKey: string, item: RegularMenuItemForLib) => {
                    renderItemContent($itemElement[0], {
                        iconClass: srcItem.iconFontAwesome || null,
                        spaceAfterIcon: false,
                        name: srcItem.name,
                        shortcutKey: srcItem.shortcutKey,
                    });

                    if (srcItem.disabled && srcItem.disabledReason) {
                        $itemElement.attr("title", srcItem.disabledReason);
                    }
                    return ""; // no special class name required
                },
                callback: srcItem.callback,
                disabled: !!srcItem.disabled,
                visible: srcItem.visible,
            }
            destItems[destItemId] = newItem;
        } else {


            destItems[destItemId] = srcItem;
        }
    }

    return destItems;
}
